import projectService from "@/service/project-service"

export default {
  devicesRef(projectId) {
    return projectService.projectRef(projectId).child("devices")
  },

  deviceRef(projectId, deviceId) {
    return this.devicesRef(projectId).child(deviceId)
  },

  deviceScreenIdRef(projectId, deviceId) {
    return this.deviceRef(projectId, deviceId).child("screenId")
  },

  deviceNameRef(projectId, deviceId) {
    return this.deviceRef(projectId, deviceId).child("name")
  },

  onDevicesChanged(projectId, callback, errorCallback) {
    this.devicesRef(projectId).on(
      "value",
      snapshot => {
        const devices = snapshot.val() || {}
        const devicesWithIdsAndNames = Object.keys(devices).reduce(
          (acc, deviceId) => {
            acc[deviceId] = {
              name: `dev-${deviceId.slice(-4)}`,
              ...devices[deviceId],
              id: deviceId
            }
            return acc
          },
          {}
        )
        callback(devicesWithIdsAndNames)
      },
      errorCallback
    )
  },

  offDevicesChanged(projectId) {
    this.devicesRef(projectId).off()
  },

  addScreenIdToDevice(projectId, deviceId, screenId) {
    return this.deviceScreenIdRef(projectId, deviceId).set(screenId)
  },

  removeScreenIdFromDevice(projectId, deviceId) {
    return this.deviceScreenIdRef(projectId, deviceId).set(null)
  },

  removeDeviceFromProject(projectId, deviceId) {
    return this.deviceRef(projectId, deviceId).set(null)
  },

  setDeviceName(projectId, deviceId, deviceName) {
    return this.deviceNameRef(projectId, deviceId).set(deviceName)
  }
}
